import React from 'react';
import {Provider} from 'react-redux';
import {message} from 'antd';
import './shared/styles/crema.less';
import {
  AppContextProvider,
  AppLayout,
  AppLocaleProvider,
  AppThemeProvider,
  AuthRoutes,
} from './@crema';
import configureStore from './redux/store';
import {BrowserRouter} from 'react-router-dom';
import './@crema/services/index';
import JwtAuthProvider from './@crema/services/auth/jwt-auth/JWTAuthProvider';

const store = configureStore();

// Never stack toasts: a newer one replaces whatever is on screen.
message.config({maxCount: 1});

const App = () => (
  <AppContextProvider>
    <Provider store={store}>
      <AppThemeProvider>
        <AppLocaleProvider>
          <BrowserRouter>
            <JwtAuthProvider>
              <AuthRoutes>
                <AppLayout />
              </AuthRoutes>
            </JwtAuthProvider>
          </BrowserRouter>
        </AppLocaleProvider>
      </AppThemeProvider>
    </Provider>
  </AppContextProvider>
);

export default App;
